import React from "react";
import { ReactComponent as InfoIcon } from "assets/svgs/info.svg";
import clsx from "clsx/lite";

const InlineNotice = ({ message, className }) => {
	if (!message) return null;

	return (
		<div className={clsx("text-xs rounded-md p-3 bg-light-beige flex items-center gap-2", className)}>
			<div className="border border-[#858585] rounded-full p-1 w-fit">
				<InfoIcon width={10} height={10} />
			</div>
			{message}
		</div>
	);
};

export default InlineNotice;